export enum CalibrationFrequency {
    Weekly = 0,
    Monthly = 1,
    Annually = 2
}